import React from "react";
import"./App.css";
import Home from "./Components/Home.tsx";
import About from "./Components/About";
// import Skills from "./Components/Skills";
import Projects from "./Components/Projects";
import Future from "./Components/Future";
import Art from "./Components/Art";
import Footer from "./Components/Footer";


function App(){
    return(
        <div className="App">
            <Home/>
            <About/>
            {/* <Skills/> */}
            <Projects/>
            <Art/>
            <Future/>
            <Footer/>
        </div>
    )
}
export default App;